/* eslint-disable react/prefer-stateless-function */
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SubsContext } from '../Billsby/SubscriptionInfo';
import { isFeatureEnabled } from '../../config/featureFlags';

const RestrictedWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 200px;
`;

const BlurredContent = styled.div`
  filter: blur(5px);
  user-select: none;
  pointer-events: none;
  opacity: 0.6;
`;

const UpgradeOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 200px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.4);
`;

const UpgradeMessage = styled.div`
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  text-align: center;
  max-width: 350px;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  border: 1px solid #eee;
`;

const UpgradeHighlight = styled.span`
  color: #F04E3F;
  display: block;
  margin-top: 0.5rem;
  font-size: 1em;
`;

export const isAllowed = (level, subscriptionLevel) => {
  if (subscriptionLevel) {
    if (level === "ICON Pro") {
      return subscriptionLevel === "ICON Pro";
    } else if (level === "ICON Plus") {
      return subscriptionLevel === "ICON Plus" ||
        subscriptionLevel === "ICON Pro";
    } else if (level === "ICON Core") {
      return subscriptionLevel === "ICON Core" ||
        subscriptionLevel === "ICON Plus" ||
        subscriptionLevel === "ICON Pro";
    } else if (level === "Undefined") {
      return subscriptionLevel === 'ICON Pro';
    }
  }
  return true;
}

const Subscription = ({ service, level, children }) => {
  const { subscriptionLevel } = useContext(SubsContext);
  if (!isFeatureEnabled('ENABLE_BILLSBY')) {
    return children;
  }

  const allowed = isAllowed(level, subscriptionLevel);

  if (allowed) {
    return children;
  }

  const upgradeText = level === 'ICON Pro'
    ? 'Upgrade to ICON Pro'
    : 'Upgrade to ICON Plus or ICON Pro';

  return (
    <RestrictedWrapper>
      <BlurredContent>
        {children}
      </BlurredContent>
      <UpgradeOverlay>
        <UpgradeMessage>
          <p>In order for {service}</p>
          <UpgradeHighlight>{upgradeText}</UpgradeHighlight>
          <Link
            to="/memberadmin/home/updateSubscription"
            className="btn"
            style={{
              backgroundColor: '#ff914d',
              borderColor: '#ff914d',
              color: '#fff',
              marginTop: '0.75rem',
            }}
          >
            Upgrade Subscription
          </Link>
        </UpgradeMessage>
      </UpgradeOverlay>
    </RestrictedWrapper>
  );
}

Subscription.propTypes = {
  service: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default Subscription;




// WEBPACK FOOTER //
// ./src/components/Subscription/Subscription.jsx